export default {
  common: { all: '全部' },
  actions: {
    publishHomework: '發佈作業', search: '查詢', reset: '重置', view: '查看', edit: '編輯', delete: '刪除',
    confirmDelete: '確認刪除', cancel: '取消', back: '返回', publish: '發佈', schedulePublish: '預約發佈',
    saveChanges: '儲存修改', confirmPublish: '確認發佈', confirmUpdate: '確認儲存', uploadAttachment: '上傳文件',
    preview: '預覽附件', remove: '移除',
  },
  fields: {
    title: '作業標題', schoolYear: '學年', grade: '級組', class: '班級', targetClasses: '發佈班級',
    subject: '科目', status: '狀態', homeworkDate: '作業日期', estimatedMinutes: '預計完成時間',
    dueTime: '截止時間', publishDate: '發佈日期', publishTime: '發佈時間', publishCutoffTime: '發佈截止時間',
    publishMode: '發佈方式', scheduledPublishTime: '預約發佈時間', content: '作業內容',
    attachments: '附件', operation: '操作', publishTimeliness: '發佈時效', publisher: '發佈人', withdrawTime: '撤回時間',
  },
  placeholders: {
    title: '請輸入作業標題', schoolYear: '請選擇學年', subject: '請選擇科目', classes: '請選擇班級（可多選）',
    homeworkDate: '請選擇作業日期', publishDate: '請選擇發佈日期', estimatedMinutes: '請輸入分鐘數', dueTime: '請選擇截止時間',
    scheduledPublishTime: '請選擇預約發佈時間', content: '請輸入作業內容',
  },
  status: { published: '已發佈', withdrawn: '已撤回', scheduled: '待發佈', ended: '已截止' },
  timeliness: { normal: '正常發佈', overtime: '超時發佈' },
  publishMode: { immediate: '立即發佈', scheduled: '預約發佈' },
  editor: {
    createTitle: '發佈學生作業', editTitle: '編輯學生作業', subtitle: '填寫作業內容並選擇發佈班級',
    homeworkInfo: '作業內容', publishRuleTitle: '發佈說明',
    publishRuleDescription: '作業日期和截止時間均以服務端業務時區為準；預約發佈時間必須早於學生完成截止時間。',
  },
  validation: {
    schoolYearRequired: '請選擇學年', subjectRequired: '請選擇科目', classRequired: '請至少選擇一個班級',
    homeworkDateRequired: '請選擇作業日期', homeworkDatePast: '作業日期不可早於今天', titleRequired: '請輸入作業標題',
    titleLength: '作業標題最多 50 個字元', contentRequired: '請輸入作業內容', contentLength: '作業內容最多 16000 個字元',
    estimatedMinutesRequired: '請輸入預計完成時間', estimatedMinutesRange: '預計完成時間需介於 1 至 65535 分鐘',
    dueTimeRequired: '請選擇截止時間', futureTime: '時間必須晚於目前時間', dueAfterHomeworkDate: '截止時間不可早於作業日期',
    scheduledTimeRequired: '請選擇預約發佈時間',
    scheduleBeforeDueTime: '預約發佈時間必須早於截止時間',
  },
  messages: {
    loadDetailFailed: '作業詳情載入失敗', scopeChanged: '目前任教範圍已變更，請重新選擇科目和班級',
    publishTitle: '確認發佈作業？', publishDescription: '發佈後將立即向選定班級的學生推送作業。',
    updateTitle: '確認儲存修改？', updateDescription: '儲存時會以目前班級和附件完整集合覆蓋原內容。',
    publishSuccess: '作業已發佈', scheduleSuccess: '作業已預約發佈', updateSuccess: '作業修改成功',
    deleteTitle: '刪除作業？', deleteDescription: '刪除後作業及其相關資料將無法恢復，請確認是否刪除。',
    deleteSuccess: '作業已刪除', uploadSuccess: '附件上傳成功', uploadFailed: '附件上傳失敗', attachmentFormatUnsupported: '不支援該附件格式，請上傳 PDF、圖片、PPT、Word 或 Excel 文件', previewFailed: '附件預覽失敗', previewOpenFailed: '瀏覽器封鎖了預覽視窗，請允許彈出視窗後重試',
    spreadsheetPreviewEmpty: '表格中沒有可預覽的資料', spreadsheetPreviewTruncated: '表格較大，僅展示前 {rows} 列和 {columns} 欄', spreadsheetPreviewFailed: '表格檔案預覽失敗',
  },
  states: { loading: '正在載入作業列表...', empty: '目前篩選條件下暫無作業', noAttachments: '暫無附件' },
  tips: { attachment: '支援 PDF、圖片、PPT、Word、Excel 等常用格式；附件需先上傳，發佈或儲存時才會與作業綁定。' },
  units: { minute: ' 分鐘' },
}
